import React from "react";
import { Box, Card, CardContent } from "@mui/material";
import { useMyWinHeightContext } from "src/common/utils/getWindowDimensions";
import CardHeading from "src/components/CardHeader/CardHeader";
import TabHeader from "src/components/TabHeader/TabHeader";
import { useStyles } from "./styles";

type Props = {
  module: string;
  children: any;
  heading: string;
  heading1?: string;
  GridDataComp?: any;
  linkTo?: string;
  pageTitle?: string;
  forQuickPay?: boolean;
  notShowTabHeading?: boolean;
  customHeigth?: number;
  customHeigthOfGrid?: number;
};

export default function CommonDataGridPage({
  module,
  children,
  heading,
  GridDataComp,
  linkTo,
  pageTitle,
  forQuickPay,
  notShowTabHeading = false,
  heading1,
  customHeigth,
  customHeigthOfGrid = 138,
}: Props) {
  const classes = useStyles();
  const { winHeight } = useMyWinHeightContext();
  let wHeight = 0;
  wHeight = heading === "List of QuickPay" ? winHeight - 347 : winHeight - customHeigthOfGrid;
  return (
    <>
      {!notShowTabHeading && (
        <>
          <TabHeader
            module={module || "module"}
            heading={heading1 || heading || "heading"}
            linkTo={linkTo}
          />
          <Box m={2} />
        </>
      )}
      {forQuickPay ? (
        <>
          <Card className={classes.card} elevation={10}>
            <CardContent className={classes.cardMain} style={{ height: customHeigth || 200 }}>
              <CardHeading heading={heading || "heading"} pageTitle={pageTitle} />
              <Box mt={0}>{children}</Box>
            </CardContent>
          </Card>
        </>
      ) : (
        <>
          <Card>
            <CardContent className={classes.cardMain} style={{ height: wHeight }}>
              <CardHeading heading={heading || "heading"} pageTitle={pageTitle} />
              <Box mt={1}>{children}</Box>
              {GridDataComp}
            </CardContent>
          </Card>
        </>
      )}
    </>
  );
}
